<template>
  <div>
    <div
      v-for="(o, i) in options"
      @click="answer = i"
      class="card p-2 mb-2"
      :class="{selected: answer === i}"
      style="cursor: pointer"
    >
      <h6 style="margin-bottom: 0">{{o.number}} {{o.sentence}}</h6>
    </div>
  </div>
</template>
<script>
export default {
  props: ["options", "value"],
  computed: {
    answer: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.value;
      }
    }
  }
};
</script>

<style lang="scss" scope>
.card.selected {
  background-color: rgb(108, 167, 245);
}
</style>

    